const NoticesRepository = Fw5MLApi => ({
  async getNotices() {
    const req = await Fw5MLApi.fetch(`/notifications`)
    return req?.data
  }
})

export default NoticesRepository
